import { useContext } from "react";
import { ModeContext } from "./ModeContext";

export const useMode = () => useContext(ModeContext); 